import logo from "assets/images/bmd-logo.png";
import "./ChatEmptyState.scss";

const ChatEmptyState = () => (
  <section className="chat-empty-state">
    <img className="chat-empty-state__logo" src={logo} alt="BMD Chat" />
    <h2 className="chat-empty-state__title">Bạn cần tra cứu gì?</h2>
  </section>
);

export default ChatEmptyState;
